import React, { Component } from "react";
import apiClient from "../lib/apiClient";

class EditSong extends Component {
  constructor() {
    super();
    this.state = {
      id: location.href.split("/"),
      name: "",
      artist: "",
      pageNum: undefined,
      isLoading: true
    }
  }

  async componentDidMount() {
    const { id } = this.state;
    const song = await apiClient.getOneSong(id[id.length - 1]);
    const { name, artist, pageNum } = song;
    return this.setState({ isLoading: false, name, artist, pageNum, id: id[id.length - 1] });
  }


  handleChange = (event) => {
    const { name, value } = event.target;
    return this.setState({ [name]: value });
  }

  handleSubmit = async (event) => {
    event.preventDefault();
    const { id, name, artist, pageNum } = this.state;
    await apiClient.editSong(id, { name, artist, pageNum });
    location.href = "https://max-and-sax.netlify.app/jukebox";
  }

  deleteSong = async () => {
    const { id } = this.state;
    await apiClient.deleteSong(id);
    location.href = "https://max-and-sax.netlify.app/jukebox";
  }

  render() {
    const { isLoading, name, artist, pageNum  } = this.state;
    if (isLoading) {
      return <p>Loading...</p>
    }
    return (
      <div className="flex flex-col items-center w-96 pt-10 main h-2/3">
        <p>Edita la cançó</p>
        <form onSubmit={this.handleSubmit}>
          <label>Títol</label>
          <input className="formInput" type="text" value={name} name="name" onChange={this.handleChange} />
          <label>Artista</label>
          <input className="formInput" type="text" value={artist} name="artist" onChange={this.handleChange} />
          <label>Número de pàgina</label>
          <input className="formInput" type="number" value={pageNum} name="pageNum" onChange={this.handleChange} />
          <div className="text-center">
            <input className="button" type="submit" value="Actualitza" />
          </div>
        </form>
            <button className="redbutton" onClick={this.deleteSong}>Elimina</button>
      </div>
    )
  }
}

export default EditSong;